import { useState, createContext } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

export const LocaleContext = createContext()

export default function LocaleProvider({ children }) {
  const [language, setLanguage] = useState('ita')

  const localeImgSources = {
    ita: process.env.PUBLIC_URL + '/images/locale-flags/italy.png',
    eng: process.env.PUBLIC_URL + '/images/locale-flags/united-kingdom.png'
  }

  const handleClick = () => {
    switch(language){
      case 'ita': return setLanguage('eng')
      case 'eng': return setLanguage('ita')
      default: return 'ita'
    }
  }

  const LocaleSwitch = () => {
    return(
      <div id='locale'>
        <OverlayTrigger
          placement='right'
          overlay={
            <Tooltip id="tooltip-language">
              {
                language === 'ita' ? 
                  'Switch to eng'
                :
                  'Switch to ita'
              }
            </Tooltip>
          }
        >
          <Button onClick={() => handleClick()}>
            <img
                  src={localeImgSources[language]}
                  className="img-fluid"
                  alt="locale flag" />
          </Button>
        </OverlayTrigger>
      </div>
    )
  }

  return (
    <LocaleContext.Provider
      value={{
          language,
          LocaleSwitch
      }}
    >
      {children}
    </LocaleContext.Provider>
  )

}
